import { Component, Input, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ForbrukService } from 'src/app/services/forbruk/forbruk.service';
import {
  Anlegg,
  AnleggAar,
  AnleggMaaned,
  ChartType
} from 'src/app/services/forbruk/forbruk.types';

@Component({
  selector: 'app-chart-kostnad',
  templateUrl: './kostnad.component.html',
  styleUrls: ['./kostnad.component.scss']
})
export class ChartKostnadComponent implements OnInit {
  @Input() isBrowser: boolean;
  @Input() hasFetchingError: boolean;
  @Input() valgtAarAnlegg: AnleggAar;
  @Input() minDate: Date;
  @Input() valgtMaanedAnlegg: AnleggMaaned;
  @Input() selectedDateMonth: Date;
  @Input() valgtDagAnlegg: Anlegg;
  @Input() selectedDateDay: Date;
  @Input() valgtTimeAnlegg: Anlegg;
  @Input() selectedDateHour: Date;
  @Input() isStromstotteToggled: boolean;

  _chartTypes: ChartType;
  subscription: Subscription;
  constructor(private _forbrukService: ForbrukService) {}

  ngOnInit() {
    this.subscription = this._forbrukService
      .getChartType()
      .subscribe((chartTypes) => {
        this._chartTypes = chartTypes;
      });
  }

  ngOnDestory() {
    this.subscription?.unsubscribe();
  }
}
